import React from 'react';
import Anchor from '../objects/Anchor'

const BreakBanner = props => {

    const {title, copy, cta_text, cta_link, key} = props;

    const image = '/images/home-tiles-profile.jpg';

    return (
        <div className="col-12 break-banner" key={key}>
            <div className="image" style ={ { backgroundImage: `url(${image})` } }></div>
            <div className="break-inner">
                { title && <h4 className="heading-two">{title}</h4>}
                { copy && <p className="body-copy">{copy}</p>}
                { cta_link && <Anchor path={cta_link} anchorClass={'theme-button'} internal>
                    {cta_text}
                </Anchor> }
            </div>
        </div>
    );

};

export default BreakBanner;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/BreakBanner.js